import _ from "lodash";
import module from "./module";

export default _.merge({}, module);
